<template>
    <div :key="key">
        <b-row v-if="dayIsEditable && monthIsEditable">
            <b-col sm="3" class="text-left pr-0">
                <b-input
                    ref="date"
                    v-model="form.deadline_day"
                    size="sm"
                    class="text-primary font-weight-bold"
                    :class="reactiveClass"
                    style="cursor: pointer"
                    @change="handleNewDay"
                />
            </b-col>
            <b-col sm="9" class="text-left pl-0">
                <b-select
                    v-model="form.deadline_month"
                    size="sm"
                    class="text-primary font-weight-bold"
                    :class="reactiveClass"
                    :options="months_list"
                    style="cursor: pointer"
                    @change="handleNewMonth"/>
            </b-col>
        </b-row>
        <b-row v-if="dayIsEditable && !monthIsEditable">
            <b-col sm="3" class="text-left pr-0">
                <b-input
                    ref="date"
                    v-model="form.deadline_day"
                    size="sm"
                    class="text-primary font-weight-bold"
                    :class="reactiveClass"
                    style="cursor: pointer"
                    @change="handleNewDay"
                />
            </b-col>
            <b-col sm="9" class="text-left" style="padding-left: 5px">
                <span>{{ months }}</span>
            </b-col>
        </b-row>
        <b-row v-if="!dayIsEditable" class="text-left">
            <b-col sm="3" class="text-right" style="padding-right: 5px">
                <span>{{ deadline_day }}</span>
            </b-col>
            <b-col sm="9" class="text-left" style="padding-left: 10px">
                <span>{{ months }}</span>
            </b-col>
        </b-row>

        <b-modal
            ref="apply-new-date-modal"
            hide-footer
            title="Application de la date saisie"
        >
            <p>
                A partir de quand souhaitez-vous appliquer cette date sur les
                échéances ?
            </p>
            <b-input-group class="mb-3">
                <b-form-input
                    id="current-date"
                    v-model="formatted_current_date"
                    type="text"
                    autocomplete="off"
                    disabled
                    class="bg-white"
                />
                <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.from_date"
                        button-only
                        right
                        size="sm"
                        label-no-date-selected="A partir du..."
                        label-prev-year="Année précédente"
                        label-next-year="Année prochaine"
                        label-prev-month="Mois précédent"
                        label-next-month="Mois prochain"
                        label-current-month="Mois actuel"
                        label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                        start-weekday="1"
                        aria-controls="current-date"
                        locale="fr"
                        @context="formatCurrentDate"
                    >
                    </b-form-datepicker>
                </b-input-group-append>
            </b-input-group>
            <b-button
                variant="success"
                :disabled="form.from_date === null"
                @click="saveDate"
            >
                Enregistrer
            </b-button>
            <b-button variant="secondary" @click="hideModal">
                Annuler
            </b-button>
        </b-modal>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler'
import ToastHandler from '../../../invoicing/mixins/ToastHandler.vue'

export default {
    name: 'ActionDateForm',

    mixins: [TableFormHandler, ToastHandler],

    props: {
        action: {
            required: true,
            type: Object
        },
        year: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            deadline_day: null,
            months: null,
            form: {
                deadline_day: null,
                deadline_month: null,
                from_date: null,
                year: null,
                updating: null,
            },
            formatted_current_date: '',
            months_list: [
                {value: '1', text: 'jan'},
                {value: '2', text: 'fév'},
                {value: '3', text: 'mar'},
                {value: '4', text: 'avr'},
                {value: '5', text: 'mai'},
                {value: '6', text: 'jun'},
                {value: '7', text: 'jul'},
                {value: '8', text: 'aoû'},
                {value: '9', text: 'sep'},
                {value: '10', text: 'oct'},
                {value: '11', text: 'nov'},
                {value: '12', text: 'déc'}
            ]
        }
    },

    computed: {

        submitUrl() {
            return this.action.menu.can_edit_day
                ? `/clientActions/${this.action.id}/day`
                : `/clientActions/${this.action.id}/date`
        },
        dayIsEditable() {
            return this.year === 'Y0'
                ? this.action.deadline_day_y0_is_editable
                : this.action.deadline_day_y1_is_editable
        },
        monthIsEditable() {
            return this.year === 'Y0'
                ? this.action.deadline_month_y0_is_editable
                : this.action.deadline_month_y1_is_editable
        },
    },

    created() {
        this.align = 'right'
        this.form.from_date = new Date()
        this.init()
    },

    methods: {
        init() {
            this.deadline_day = this.year === 'Y0'
                ? this.action.deadline_day_y0
                : this.action.deadline_day_y1
            this.months = this.year === 'Y0'
                ? this.action.months_y0
                : this.action.months_y1
            this.form.deadline_month = this.year === 'Y0'
                ? this.action.deadline_month_y0_value
                : this.action.deadline_month_y1_value
            this.form.deadline_day = this.deadline_day
            this.form.year = this.year
        },
        handleNewDay() {
            this.form.updating = 'day'
            this.$refs['apply-new-date-modal'].show()
        },
        handleNewMonth() {
            this.form.updating = 'month'
            this.$refs['apply-new-date-modal'].show()
        },
        hideModal() {
            this.$refs['apply-new-date-modal'].hide()
        },
        // async saveAction() {
        //     try {
        //         await axios.put(
        //             this.submitUrl,
        //             this.form
        //         )
        //         this.handleSuccess()
        //         this.$emit('date-is-updated')
        //     } catch (error) {
        //         this.handleError()
        //     }
        // },

        async saveDate() {
            if (this.form.updating === 'day') {
                await this.saveDay()
            } else if (this.form.updating === 'month') {
                await this.saveMonth()
            }
        },

        async saveDay() {
            this.showRecordingToast()
            try {
                let response = await axios.put(
                    `/clientActions/${this.action.id}/day`,
                    this.form
                )
                this.handleSuccess()
                this.handleRecordingResponse(response.data.meta)
                this.$emit('date-is-updated')
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        async saveMonth() {
            this.showRecordingToast()
            try {
                let response = await axios.put(
                    `/clientActions/${this.action.id}/month`,
                    this.form
                )
                this.handleSuccess()
                this.handleRecordingResponse(response.data.meta)
                this.$emit('date-is-updated')
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },
        setInitialKey() {
            this.key = `date${this.action.id}`
        },

        unFocus() {
            this.$refs.date.blur()
        },

        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
        },

    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}

.custom-select-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
    text-align: left !important;
    background: none !important;
}
</style>
